import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSun = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M10 4.25v-1.5m-4.25 3-1-1M4.25 10h-1.5m3 4.25-1 1m5.25.5v1.5m4.25-3 1 1m.5-5.25h1.5m-3-4.25 1-1M10 13.25c1.8 0 3.25-1.45 3.25-3.25S11.8 6.75 10 6.75 6.75 8.2 6.75 10 8.2 13.25 10 13.25Z"
	})]
});
const ForwardRef = forwardRef(SvgSun);
export { ForwardRef as ReactComponent };
